module.exports = __webpack_public_path__ + "img/ejemplo-7.4f9ca681.jpg";